import styled from 'styled-components';
import { DropdownMenuItem } from 'components/dropdown/dropdown';
import { ArrowUpDown } from 'lucide-react';

export const TimeRangeDropdownItem = styled(DropdownMenuItem).attrs<{
  $isSelected?: boolean;
}>(({ $isSelected }) => ({
  className: `flex flex-row items-center h-8 px-1.5 py-1 gap-1.5 isolate w-full rounded-lg flex-none order-0 self-stretch flex-grow-0 cursor-pointer ${
    $isSelected ? 'bg-[rgba(84,110,180,0.1)]' : ''
  }`,
}))<{ $isSelected?: boolean }>``;

export const DropdownItemText = styled.span.attrs({
  className:
    'flex-1 text-sm font-medium leading-5 text-gray-950 font-["Lato"] z-[1] overflow-hidden text-ellipsis whitespace-nowrap',
})``;

export const DropdownItemCheckWrapper = styled.div.attrs({
  className: 'flex-none w-4 h-4 flex items-center justify-center z-[2]',
})``;

export const DropdownItemIconWrapper = styled.div.attrs({
  className: 'flex-none w-4 h-4 flex items-center justify-center z-[0]',
})``;

export const SortIconStyled = styled(ArrowUpDown).attrs({
  className: 'h-4 w-4',
})``;

export const ActionButton = styled.button.attrs({
  className:
    'flex items-center gap-1 text-sm font-medium text-ring-light hover:opacity-80 transition-opacity whitespace-nowrap',
})``;
